// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goal-preview-stats[data-v-aea8aa32]{color:var(--text-text-default)}.goal-preview-stats .title[data-v-aea8aa32]{font-weight:700;margin-bottom:1rem;margin-right:3rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:36px}", ""]);
// Exports
module.exports = exports;
